var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.694 35.694",
    enableBackground: "new 0 0 35.694 35.694",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F1C233",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    d: "M31.045,33.313H4.649 c-2.867,0-4.699-3.054-3.35-5.583L13.4,5.05c0.876-1.643,2.586-2.668,4.447-2.668c1.861,0,3.572,1.026,4.447,2.668l12.101,22.68 C35.744,30.259,33.912,33.313,31.045,33.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F1C233",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    d: "M19.748,12.511l-0.483,8.729 c-0.035,0.637-0.562,1.136-1.2,1.136h-0.433c-0.638,0-1.165-0.499-1.201-1.136l-0.483-8.729c-0.058-1.045,0.774-1.924,1.821-1.924 h0.16C18.974,10.587,19.806,11.465,19.748,12.511z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#F1C233",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    cx: 17.847,
    cy: 26.984,
    r: 1.806
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.34ebccd7935a81554fc6d4bdbbae2ff7.svg";
export { ForwardRef as ReactComponent };